import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMoveEmphasis24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconMoveEmphasis24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M20.38 3.314a.9.9 0 0 1-.9.9H4.537a.901.901 0 0 1 0-1.8H19.48a.9.9 0 0 1 .9.9m0 17.355a.9.9 0 0 1-.9.9H4.537a.901.901 0 0 1 0-1.8H19.48a.9.9 0 0 1 .9.9m-2.83-8.678a5.55 5.55 0 0 1-5.266 5.544l-.285.008a5.55 5.55 0 0 1-5.544-5.266l-.008-.286a5.552 5.552 0 0 1 11.103 0m-1.8 0a3.752 3.752 0 1 0-7.503.002 3.752 3.752 0 0 0 7.503-.002"
            />
        </svg>
    );
}
export default memo(IconMoveEmphasis24);
